import { Link } from 'react-router-dom';
import { siteInfo, navItems } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-shield-check-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading font-bold text-lg whitespace-nowrap text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-secondary-300 text-sm leading-relaxed">
              {siteInfo.tagline}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 rounded-lg bg-secondary-800 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href={`https://douyin.com/@${siteInfo.socialLinks.douyin}`} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 rounded-lg bg-secondary-800 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href={`mailto:${siteInfo.email}`} className="w-9 h-9 rounded-lg bg-secondary-800 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {navItems.slice(0, 4).map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-secondary-300 hover:text-background-50 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">推荐平台</h4>
            <ul className="flex flex-col gap-2.5">
              <li><span className="text-secondary-300 text-sm">抖音短视频</span></li>
              <li><span className="text-secondary-300 text-sm">快手</span></li>
              <li><span className="text-secondary-300 text-sm">Bilibili（B站）</span></li>
              <li><span className="text-secondary-300 text-sm">微信视频号</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-secondary-300 text-sm">
                <i className="ri-mail-line text-sm"></i>
                <a href={`mailto:${siteInfo.email}`} className="hover:text-background-50 transition-colors cursor-pointer">{siteInfo.email}</a>
              </li>
              <li className="flex items-center gap-2 text-secondary-300 text-sm">
                <i className="ri-phone-line text-sm"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-secondary-300 text-sm">
                <i className="ri-map-pin-line text-sm mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-secondary-400 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 版权所有。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-secondary-400 text-xs">京ICP备XXXXXXXX号</span>
            <span className="text-secondary-400 text-xs">京公网安备 XXXXXXXX号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}